const ModalService = {
  //显示加载中
  showLoading(dispatch: Function) {
    dispatch({ type: 'showLoading' });
  },

  //隐藏加载中
  hideLoading(dispatch: Function) {
    dispatch({ type: 'hideLoading' });
  },

  //显示提示
  showTip(message: string, dispatch: Function) {
    dispatch({ type: 'showTip', message });
    setTimeout(() => {
      dispatch({ type: 'hideTip' });
    }, 2000);
  },

  //显示错误
  showError(
    errorMsg: string | undefined,
    dispatch: Function,
    hideTimeout: number = 2000
  ) {
    dispatch({ type: 'showError', errorMsg });
    if (hideTimeout) {
      setTimeout(() => {
        dispatch({ type: 'hideError' });
      }, hideTimeout);
    }
  },

  //退回，撤回，审批
  async showReject(
    content: string = '退回',
    ok = () => {},
    title: string = '退回原因',
    type: string = 'reject',
    reasonStr: string = '',
    dispatch
  ) {
    let option = {
      content,
      type,
      ok,
      title,
      reasonStr
    };
    dispatch(option);
  },

  //三层确认（更新/不更新/取消）
  async showThreeConfirm(
    content: string = '',
    update = () => {},
    noUpdate = () => {},
    cancel = () => {},
    title: string = '操作提示',
    updateText: string = '更新',
    noUpdateText: string = '不更新',
    cancelText: string = '取消',
    dispatch: Function
  ) {
    let option = {
      content,
      type: 'showThreeConfirm',
      update,
      noUpdate,
      cancel,
      title,
      updateText,
      noUpdateText,
      cancelText
    };
    dispatch(option);
  },

  //二次确认
  async showConfirm(
    content: string = '',
    ok = () => {},
    dispatch: Function,
    title: string = 'BASE.OPERATE_NOTICE',
    okText: string = 'BUTTON.OK',
    cancelText: string = 'BUTTON.CANCEL',
    cancel = () => {}
  ) {
    let option = {
      content,
      type: 'showConfirm',
      ok,
      title,
      okText,
      cancelText,
      cancel
    };
    dispatch(option);
  }
};

export default ModalService;
